import { lazy } from "react"

const templateRegistry = {
    //Admin
    dash: lazy(() => import("Components/AdminTemplates/dash")),
    theme: lazy(() => import("Components/AdminTemplates/ThemeGen/index")),

    //Normal
	hero: lazy(() => import("Components/Templates/hero")),
	features: lazy(() => import("Components/Templates/features")),
	pricing: lazy(() => import("Components/Templates/pricing")),
	contact: lazy(() => import("Components/Templates/contact")),
	login: lazy(() => import("Components/Templates/login")),
	register: lazy(() => import("Components/Templates/register")),
    account: lazy(() => import("Components/Templates/account")),
}

export default templateRegistry
